<template>
  <div class="p-competing-serps" :style="{ top: notificationsHeight + 'px' }">
    <div
      class="p-competing-serps__inner"
      :style="{
        'max-height': 'calc(100vh - ' + notificationsHeight + 'px)'
      }"
    >
      <div v-if="isGuide" class="p-competing-serps-guide">
        <h3 class="p-competing-serps-guide__title">
          各キーワードの上位検索結果を表示
        </h3>
        <p
          class="p-competing-serps-guide__text"
          :class="{ 'is-loading': isLoading }"
        >
          左のキーワードをクリックすると、
          <br />
          キーワードの検索結果を表示します。
        </p>
      </div>
      <template v-else>
        <div class="p-competing-serps__header">
          <h3 v-if="selected.keyword" class="p-competing-serps__title">
            <p>｢{{ selected.keyword }}｣の検索結果</p>
          </h3>
          <span v-if="selected.searchVolume" class="p-competing-serps__volume">
            月間検索数 {{ selected.searchVolume | separateNumber }}
          </span>
        </div>
        <Error v-if="!data.items.length" variant="inline" size="sm">
          <template slot="title">
            データがありません。
          </template>
        </Error>
        <div
          v-else
          class="p-competing-serps__scroll"
          :style="{ height: listOuterH + 'px' }"
        >
          <perfect-scrollbar
            :options="{ suppressScrollX: true, minScrollbarLength: 10 }"
          >
            <div class="p-competing-serps-head" ref="head">
              <div class="p-competing-serps-head__result">
                検索結果
                <Tooltip size="sm">
                  SEARCH
                  WRITEで検索結果画面のタイトルから該当ページに訪れるユーザーの意図を読み取り、自動で「行きたい」「買いたい」「知りたい」「比べたい」の4種類に分類します。
                </Tooltip>
              </div>
              <div class="p-competing-serps-head__volume">
                想定流入数
              </div>
            </div>
            <ul class="c-list--ranking" ref="list">
              <ListItemSuggestSerps
                v-for="(item, index) in data.items.slice(0, 10)"
                :key="index"
                :item="item"
                :project="project"
              />
              <ListItemSuggestSerps
                v-if="hasMySerps"
                :item="data.myserps"
                :project="project"
              />
            </ul>
          </perfect-scrollbar>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Error from '@/components/Error';
import ListItemSuggestSerps from '@/components/competitiveKeyword/ListItemSuggestSerps';
import apiIntents from '@/api/intents';
import apiProjects from '@/api/projects';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import axios from 'axios';
import Tooltip from '@/components/Tooltip';

export default {
  props: ['project', 'selected', 'startDate', 'selectedTab'],
  components: {
    Error,
    ListItemSuggestSerps,
    Tooltip,
    PerfectScrollbar
  },
  data() {
    return {
      data: {
        items: [],
        myserps: {
          inflowNumber: null,
          intent: null,
          rank: null,
          title: null,
          url: null
        }
      },
      errorResponse: '',
      listOuterH: 0,
      request: {
        cancelTokens: []
      },
      isLoading: false
    };
  },
  computed: {
    notificationsHeight() {
      return this.$store.state.view.size.notificationsHeight;
    },
    hasMySerps() {
      return this.data.myserps.title ? true : false;
    },
    isGuide() {
      return this.isLoading || !this.selected.keyword;
    }
  },
  watch: {
    'data.items': {
      handler() {
        this.setHeight();
      },
      immediate: true
    },
    selected: {
      handler() {
        this.cancelRequests();
        this.data.items = [];
        this.data.myserps = {
          inflowNumber: this.selected.searchVolumeByProject,
          intent: null,
          rank: null,
          title: null,
          url: null
        };
        this.getSerps();
      },
      immediate: true
    },
    hasMySerps: {
      handler() {
        this.setHeight();
      },
      immediate: true
    },
    selectedTab: {
      handler() {
        // デモモードはインテントのデータを切り替えるので、Serpsとインテントを取得し直す
        if (process.env.VUE_APP_ENV === 'demo') {
          this.getSerps();
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    this.cancelRequests();
  },
  methods: {
    cancelRequests() {
      if (this.request.cancelTokens.length) {
        for (let i = 0; i < this.request.cancelTokens.length; i++) {
          this.request.cancelTokens[i].cancel();
        }
        this.request.cancelTokens = [];
      }
    },
    getSerps() {
      if (!this.selected.keyword || !this.selected.startDate) {
        return;
      }
      this.isLoading = true;

      const params = {
        keyword: this.selected.keyword,
        date: this.$options.filters.dateText(this.selected.startDate),
        url: this.project.siteUrl
      };

      const cancelToken = axios.CancelToken.source();
      this.request.cancelTokens.push(cancelToken);

      return apiProjects.suggestAnalyses.serps
        .get(params, this.auth.idToken, this.project.id, cancelToken.token)
        .then(response => {
          this.data.items = response.data.items;
          // インテントを取得する
          for (let i = 0; i < this.data.items.length; i++) {
            const item = this.data.items[i];
            if (item.title) {
              this.getIntent(item.title, i)
                .then(response => {
                  let obj = Object.assign({}, this.data.items[i]);
                  obj.intent = response.data;
                  this.data.items.splice(i, 1, obj);
                })
                .catch(error => {});
            }
          }
          // 10位以内に自社のURLが含まれない場合は、11～100位の情報を取得する
          if (
            this.data.items.length &&
            !this.data.items.some(
              item => item.url.indexOf(this.project.siteUrl) === 0
            )
          ) {
            this.getMySerps();
          }
          this.isLoading = false;
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            if (error.response) {
              this.errorResponse = error.response.data.errors[0].userMessage;
            }
            this.isLoading = false;
          }
        });
    },
    getMySerps() {
      const params = {
        keyword: this.selected.keyword,
        dateJst: this.startDate,
        location: 'tokyo',
        engine: 'google',
        device: 'desktop',
        fromRank: 11,
        toRank: 100
      };

      const cancelToken = axios.CancelToken.source();
      this.request.cancelTokens.push(cancelToken);

      return apiProjects.serps
        .get(params, this.auth.idToken, this.project.id, cancelToken.token)
        .then(response => {
          for (let i = 0; i < response.data.items.length; i++) {
            const item = response.data.items[i];
            if (item.url.indexOf(this.project.siteUrl) === 0) {
              this.data.myserps.rank = item.rank;
              this.data.myserps.title = item.title;
              this.data.myserps.url = item.url;
              this.getIntent(item.title)
                .then(response => {
                  this.data.myserps.intent = response.data;
                })
                .catch(error => {});
              break;
            }
          }
        })
        .catch(error => {});
    },
    getIntent(word, index = 0) {
      const params = {
        word: word
      };
      const cancelToken = axios.CancelToken.source();
      this.request.cancelTokens.push(cancelToken);

      return apiIntents.get(
        params,
        this.auth.idToken,
        cancelToken.token,
        index + 1,
        this.selectedTab
      );
    },
    setHeight() {
      this.$nextTick(() => {
        if (!this.$refs.list) {
          return;
        }
        this.listOuterH =
          this.$refs.head.clientHeight + this.$refs.list.clientHeight;
      });
    }
  }
};
</script>
